import styled from 'styled-components';
import { black, white, primaryColor } from 'Public/Css/colors';

export default styled.div `
    
    color: ${ black };
    
    .anticon {
        color: ${ primaryColor };
        border-radius: 100%;
        padding: 4px;
        font-size: 16px;
        display: inline-block;
        margin-right: 8px;
        vertical-align: middle;
        cursor: default;
    }
    
    .pipe {
        display: inline-block;
        margin: 0 6px;
        color: ${ white };
    }
  
`;
